import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-get-post-id',
  templateUrl: './get-post-id.component.html',
  styleUrls: ['./get-post-id.component.css']
})
export class GetPostIdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
